import { Box } from '@material-ui/core';
import React from 'react';

type Props = {
  text: string;
  verticalPositionTop?: boolean;
};

export const EmptyStateWithText: React.VFC<Props> = ({ text, verticalPositionTop }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: verticalPositionTop ? 'flex-start' : 'center',
        marginTop: verticalPositionTop ? 2 : 0,
        height: '300px',
      }}
    >
      {text}
    </Box>
  );
};
